var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("main", { staticClass: "home-page" }, [
      _c("section", { staticClass: "device-card" }, [
        _c("div", { staticClass: "device-head" }, [
          _c("img", {
            staticClass: "avatar",
            attrs: {
              src: require("./static/images/home-avatar.png"),
              alt: "头像"
            }
          }),
          _vm._v(" "),
          _c("div", [
            _c("h1", [
              _c(
                "button",
                {
                  staticClass: "device-no-btn",
                  attrs: { type: "button" },
                  on: { click: _vm.onCopySuccess }
                },
                [
                  _c("span", [
                    _vm._v(
                      "设备号：" +
                        _vm._s(_vm.operator.short_number || _vm.iccid)
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "copy-icon",
                    attrs: { "aria-hidden": "true" }
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                _vm._s(
                  _vm.expireDate
                    ? _vm.expireDate.replace(/\//g, "-")
                    : "--/--/--"
                ) + "到期"
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.operator.system === "SHUANGKAONE"
          ? _c(
              "div",
              { staticClass: "status-row" },
              _vm._l(_vm.shuangkaList, function(item) {
                return _c(
                  "div",
                  { key: item.type, staticClass: "status-box" },
                  [
                    _c("p", [
                      _vm._v(_vm._s(_vm.operatorType[item.type]) + "状态："),
                      _c(
                        "span",
                        {
                          class: {
                            "status-value--danger": _vm.isDangerStatus(
                              item.statusName
                            )
                          }
                        },
                        [_vm._v(_vm._s(item.statusName || "查询中"))]
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(_vm._s(_vm.operatorType[item.type]) + "实名："),
                      _c(
                        "span",
                        { class: { "status-value--danger": item.auth !== 1 } },
                        [_vm._v(_vm._s(item.auth === 1 ? "已实名" : "未实名"))]
                      )
                    ])
                  ]
                )
              }),
              0
            )
          : _c("div", { staticClass: "status-row" }, [
              _c("div", { staticClass: "status-box" }, [
                _c("p", [
                  _vm._v("卡状态："),
                  _c(
                    "span",
                    {
                      class: {
                        "status-value--danger": _vm.isDangerStatus(
                          _vm.simStatusName
                        )
                      }
                    },
                    [_vm._v(_vm._s(_vm.simStatusName))]
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("实名："),
                  _c(
                    "span",
                    {
                      class: { "status-value--danger": _vm.simAuthStatus !== 1 }
                    },
                    [_vm._v(_vm._s(_vm.simAuthStatusName))]
                  )
                ])
              ])
            ]),
        _vm._v(" "),
        _c("div", { staticClass: "flow-row" }, [
          _c("div", { staticClass: "flow-box" }, [
            _c("p", [_vm._v(_vm._s(_vm.usedUsage) + "G")]),
            _c("p", [_vm._v("已用流量")])
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.$router.push({
                    name: "bind",
                    query: { nostorage: 1 }
                  })
                }
              }
            },
            [_vm._v("更换卡号")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "panel" }, [
        _c("h2", [_vm._v("流量套餐")]),
        _vm._v(" "),
        _c("div", { staticClass: "menu three-cols" }, [
          _c(
            "div",
            {
              staticClass: "menu-item",
              on: { click: _vm.handleRechargeBtnClick }
            },
            [
              _c("img", {
                staticClass: "service-icon",
                attrs: {
                  src: require("./static/images/image/home-goumaitaocan.png"),
                  alt: ""
                }
              }),
              _c("span", [_vm._v("购买套餐")])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "menu-item",
              on: {
                click: function($event) {
                  return _vm.$router.push({
                    name: "order",
                    query: { iccid: _vm.iccid }
                  })
                }
              }
            },
            [
              _c("img", {
                staticClass: "service-icon",
                attrs: {
                  src: require("./static/images/image/home-chongzhijilu.png"),
                  alt: ""
                }
              }),
              _c("span", [_vm._v("充值记录")])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "menu-item",
              on: {
                click: function($event) {
                  return _vm.$router.push({
                    name: "usage",
                    query: { iccid: _vm.iccid }
                  })
                }
              }
            },
            [
              _c("img", {
                staticClass: "service-icon",
                attrs: {
                  src: require("./static/images/image/home-liuliangchaxun.png"),
                  alt: ""
                }
              }),
              _c("span", [_vm._v("流量查询")])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "panel" }, [
        _c("h2", [_vm._v("我的服务")]),
        _vm._v(" "),
        _c("div", { staticClass: "menu service-grid" }, [
          _c(
            "div",
            { staticClass: "menu-item", on: { click: _vm.flushPage } },
            [
              _c("img", {
                staticClass: "service-icon",
                attrs: {
                  src: require("./static/images/image/home-shuaxinwangluo.png"),
                  alt: ""
                }
              }),
              _c("span", [_vm._v("刷新网络")])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "menu-item", on: { click: _vm.checkCard } },
            [
              _c("img", {
                staticClass: "service-icon",
                attrs: {
                  src: require("./static/images/image/home-zhenduan.png"),
                  alt: ""
                }
              }),
              _c("span", [_vm._v("诊断")])
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "menu-item menu-item-link",
              attrs: { href: _vm.customerUrl || "javascript:;" }
            },
            [
              _c("img", {
                staticClass: "service-icon",
                attrs: {
                  src: require("./static/images/image/home-kefu.png"),
                  alt: ""
                }
              }),
              _c("span", [_vm._v("客服")])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "menu-item",
              on: { click: _vm.handleRealnameClick }
            },
            [
              _c("img", {
                staticClass: "service-icon",
                attrs: {
                  src: require("./static/images/image/home-shiming.png"),
                  alt: ""
                }
              }),
              _c("span", [_vm._v("实名")])
            ]
          ),
          _vm._v(" "),
          _vm.showChinaMobileSecondRealname
            ? _c(
                "div",
                {
                  staticClass: "menu-item",
                  on: { click: _vm.handleChinaMobileRealnameClick }
                },
                [
                  _c("img", {
                    staticClass: "service-icon",
                    attrs: {
                      src: require("./static/images/image/home-shiming.png"),
                      alt: ""
                    }
                  }),
                  _c("span", [_vm._v("移动二次认证")])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "menu-item",
              on: {
                click: function($event) {
                  return _vm.$router.push({
                    name: "device",
                    query: { iccid: _vm.operator.short_number || _vm.iccid }
                  })
                }
              }
            },
            [
              _c("img", {
                staticClass: "service-icon",
                attrs: {
                  src: require("./static/images/image/home-shebeiguanli.png"),
                  alt: ""
                }
              }),
              _c("span", [_vm._v("设备管理")])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "menu-item",
              on: {
                click: function($event) {
                  return _vm.$router.push({
                    name: "follow",
                    query: { iccid: _vm.operator.short_number || _vm.iccid }
                  })
                }
              }
            },
            [
              _c("img", {
                staticClass: "service-icon",
                attrs: {
                  src: require("./static/images/image/home-gongzhonghao.png"),
                  alt: ""
                }
              }),
              _c("span", [_vm._v("公众号")])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "menu-item",
              on: {
                click: function($event) {
                  return _vm.$router.push({
                    name: "feedback",
                    query: { iccid: _vm.operator.short_number || _vm.iccid }
                  })
                }
              }
            },
            [
              _c("img", {
                staticClass: "service-icon",
                attrs: {
                  src: require("./static/images/image/home-guanfangtousu.png"),
                  alt: ""
                }
              }),
              _c("span", [_vm._v("官方投诉")])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "menu-item",
              on: {
                click: function($event) {
                  return _vm.$router.push({
                    name: "bind",
                    query: { nostorage: 1 }
                  })
                }
              }
            },
            [
              _c("img", {
                staticClass: "service-icon",
                attrs: {
                  src: require("./static/images/image/home-tuichudenglu.png"),
                  alt: ""
                }
              }),
              _c("span", [_vm._v("退出登录")])
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _vm.showRealnameModal
      ? _c(
          "div",
          {
            staticClass: "mask",
            on: {
              click: function($event) {
                if ($event.target !== $event.currentTarget) {
                  return null
                }
                return _vm.closeRealnameModal($event)
              }
            }
          },
          [
            _c("div", { staticClass: "realname-sheet" }, [
              _c("div", { staticClass: "sheet-head" }, [
                _c("p", [_vm._v("设备实名才可以使用")]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    attrs: { type: "button", "aria-label": "关闭" },
                    on: { click: _vm.closeRealnameModal }
                  },
                  [_vm._v("×")]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "realname-grid" },
                _vm._l(_vm.realnameCards, function(item) {
                  return _c(
                    "div",
                    {
                      key: item.type,
                      staticClass: "realname-card",
                      class: { "realname-card--clickable": item.auth !== 1 },
                      on: {
                        click: function($event) {
                          return _vm.handleRealnameCardClick(item)
                        }
                      }
                    },
                    [
                      _c("h3", [
                        _vm._v(_vm._s(_vm.operatorType[item.type]) + "实名")
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        { class: { "status-value--danger": item.auth !== 1 } },
                        [_vm._v(_vm._s(item.auth === 1 ? "已实名" : "未实名"))]
                      )
                    ]
                  )
                }),
                0
              )
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d6d2a22e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6d2a22e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newpage/index.vue
// module id = null
// module chunks = 